import React, {Component} from 'react';
import './Dialogs.min.css';

class LoadingDialog extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div id="dlg_loading" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png"/>
                        <div className="dlg_title_txt">3D Design Studio</div>
                        <div className="dlg_exit_spacer">    </div>
                    </div>
                    <div className="dlg_content">
                        <div className="dlg_white">

                            <div className="dlg_print_spinner">
                                <img src="images/spinner.gif" />
                                <p className="dlg_head">Loading Model...</p>
                                <p>(Load times may vary depending on connection speed and model selected)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default LoadingDialog;
